import React from 'react';
import { motion } from 'framer-motion';
import { Battery, User, Heart } from 'lucide-react';
export function PromiseSection() {
  const cards = [{
    icon: Battery,
    title: 'Confianza que se nota',
    desc: 'Aprendés a regular tu energía, hablar con intención y mantener calma aunque haya presión.'
  }, {
    icon: User,
    title: 'Presencia masculina (real, no personaje)',
    desc: 'Te volvés más atractivo porque mejoras lo que transmitís: postura, tono, límites y decisión.'
  }, {
    icon: Heart,
    title: 'Conexión auténtica',
    desc: 'Dejás de intentar impresionar y empezás a conectar. Eso cambia tus resultados.'
  }];
  return <section className="py-24 px-4 bg-bg-card relative overflow-hidden" data-id="element-250">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[400px] bg-cta-primary/5 blur-[100px] rounded-full pointer-events-none" data-id="element-251" />

      <div className="container max-w-6xl mx-auto relative z-10" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-253">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-text-primary mb-4" data-id="element-254">
            Lo que vas a lograr con este método
          </h2>
          <div className="h-1 w-24 bg-cta-primary mx-auto rounded-full" data-id="element-255" />
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-256">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-bg-primary border border-border-color rounded-2xl p-8 hover:border-cta-primary/50 transition-colors duration-300" data-id="element-257">
              <div className="w-14 h-14 bg-bg-card rounded-xl flex items-center justify-center mb-6 border border-border-color text-cta-primary" data-id="element-258">
                <card.icon className="w-7 h-7" data-id="element-259" />
              </div>
              <h3 className="text-xl font-heading font-bold text-text-primary mb-4" data-id="element-260">
                {card.title}
              </h3>
              <p className="text-text-secondary leading-relaxed" data-id="element-261">{card.desc}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="text-center mt-12 text-text-secondary font-medium" data-id="element-262">
          "No es magia. Es entrenamiento + claridad + práctica guiada."
        </motion.p>
      </div>
    </section>;
}